import { React, useState, useEffect } from 'react';

const EscrowAccount = ({  setTransectionData, transectionData }) => {

    

    const handleInputChange = (input) => {
        const name = input?.target?.name || input.name;
        const value = input?.target?.value || input.value;

        setTransectionData((prev) => {
            const updatedData = { ...prev, [name]: value };
            return updatedData;
        });
    };
    return (
        <div className="cost-center-section my-3">
            <div className={`border-box2 p-3`}>
                <div className="form-group" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))', gap: '20px' }}>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Account Code</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.accountCode} onChange={handleInputChange} name="accountCode" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Account Name</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.accountName} onChange={handleInputChange} name="accountName" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">IBAN</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.IbanNo} onChange={handleInputChange} name="IbanNo" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Bank Name</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.bankName} onChange={handleInputChange} name="bankName" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Swift Code</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.swiftCode} onChange={handleInputChange} name="swiftCode" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Bank Contact no</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.bankContactNo} onChange={handleInputChange} name="bankContactNo" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Bank Address</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.bankAddress} onChange={handleInputChange} name="bankAddress" />
                    </div>
                </div>
            </div>
        </div>
    )
}
export default EscrowAccount